<template>
  <el-dialog
    v-if="visible"
    visible
    :title="title || defaultTitle"
    show-close
    width="1000px"
    :close-on-click-modal="false"
    :before-close="() => close()"
    append-to-body
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :extras-params="extrasParams"
      :multiple="multiple"
      @choose-change="(r) => (checkedRows = r)"
    />

    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-badge :value="checkedCount" class="ml-2" v-if="multiple">
        <el-button
          type="primary"
          size="small"
          @click="confirm()"
          :disabled="!checkedCount"
        >
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </el-badge>
      <el-button
        v-if="!multiple"
        type="primary"
        size="small"
        class="ml-2"
        @click="confirm()"
        :disabled="!checkedCount"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    extrasParams: { type: Object, default: () => ({}) },
    multiple: { type: Boolean, default: false },
    confirmOnClose: { type: Boolean, default: true },
  },
  data() {
    return {
      defaultTitle:
        this.$l('INDEX.dialog_title_chooseFabrciDefault') || '选择面料信息',
      checkedRows: null,
    }
  },
  computed: {
    checkedCount() {
      if (this.multiple) {
        return !this.checkedRows ? 0 : this.checkedRows.length
      }
      return this.checkedRows ? 1 : 0
    },
  },
  methods: {
    close() {
      this.checkedRows = null
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    confirm() {
      if (!this.checkedCount) return
      this.$emit('confirm', this.checkedRows)
      if (this.confirmOnClose) this.close()
      this.checkedRows = null
    },
  },
}
</script>
